// extracted by mini-css-extract-plugin
export var scrollArea = "_og-0";